// removed by extract-text-webpack-plugin
module.exports = {"content":"nZV6HSxV5ls-zmNFzl6Wa","deviceId":"Zzm_OKqwYDmbRtSFLlxVk","title":"_2ou-NIIUVMvI-YzppqihUx","fullscreen":"_2L2D-8ne0vbRhmEl0AlHMv","nameVisible":"_3rehbYEmEYQbm8yTpYDaBS","cell":"_2aYnDVDzTm2XWH4Y7hcEx9","interactive":"_3TYl04mJtANTGXFzYUS7YW","cellCard":"_3GDphYCqpS4HuuGzD1gp23","cellCardText":"_3dD-woh47cYB7W2nrm3SoP","widget":"_2EEPtbUZe8dLg2XF4FCIlF","nameCell":"_3R4pik4YsVdj9Pg7JPByh6","clear":"mtgXFxVIUWOBh2yOLyqVt"};


//////////////////
// WEBPACK FOOTER
// ./app/pages/DashboardInit/style.scss
// module id = 634
// module chunks = 0